import store from '@/store'
const dispatch = method => (endpoint, options = {}) => {
	return store.dispatch(`api/${method}`, { endpoint, ...options })
}

export default {
	methods: {
		get: dispatch('get'),
		post: dispatch('post'),
		put: dispatch('put'),
		patch: dispatch('patch'),
		delete: dispatch('delete')
	}
}
